import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EntityPanelService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _currentModule = new BehaviorSubject<string>('');

  isOpen$ = this._isOpen.asObservable();
  currentModule$ = this._currentModule.asObservable();

  open(module: string): void {
    this._currentModule.next(module);
    this._isOpen.next(true);
  }

  close(): void {
    this._isOpen.next(false);
  }
}
